import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Divider,
  FormControl,
  InputLabel,
  List,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  FETCH_DASHBOARD_DETAIL,
  PROJECT,
  EQUIPMENT,
  TEAMS,
  FETCH_TEAM_DASHBOARD_DETAIL,
} from "../../configs/urls";
import { API_BASE_URL } from "../../configs/constant";
import { getApi } from "../../services/api";
import "../Dashboard/style.css";
import Map from "./Map";
import { fetchMapCoordinates } from "../../constant/network";
import Loader from "components/Loader";

const useStyles = makeStyles(() => ({
  dashboardContainer: {},
}));

export default function Dashboard() {
  const classes = useStyles();
  const [dashboardData, setDashboardData] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedSectorOfficer, setSelectedSectorOfficer] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [isRequesting, setIsRequestig] = useState(false);
  const [bailerList, setBailerList] = useState([]);
  const [sectorOfficerList, setSectorOfficerList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);

  const [teamsDashboardData, setTeamsDashboardData] = useState(null);
  const [projectDashboardData, setProjectDashboardData] = useState(null);
  const [dadhboardMapCoordinates, setDadhboardMapCoordinates] = useState([]);

  const fetchDashboardMapCoordinatesFunction = async (project_id) => {
    setIsRequestig(true);
    setDadhboardMapCoordinates([]);
    await axios
      .get(`${API_BASE_URL}${fetchMapCoordinates}/${project_id}`)
      .then((res) => {
        if (res?.data?.length > 0) {
          return res?.data?.map((item) => {
            setDadhboardMapCoordinates((el) => [...el, item]);
          });
        }
        setIsRequestig(false);
      })
      .catch((err) => {
        setIsRequestig(false);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const handleProjectChange = (e) => {
    const selectedProjectData = projectList.find(
      (project) => project.id == e.target.value
    );
    setSelectedTeam(null);
    setSelectedSectorOfficer(null);
    setTeamsList([]);
    if (selectedProjectData && selectedProjectData.sector_officers) {
      setSelectedProject(selectedProjectData);
      setSectorOfficerList(selectedProjectData.sector_officers);
      getAllData(e.target.value);
      fetchDashboardMapCoordinatesFunction(e.target.value);
    }
  };
  const handleSectorOfficerChange = (e) => {
    setSelectedTeam(null);
    setSelectedSectorOfficer(e.target.value);
    fetchTeams(e.target.value);
  };
  const handleTeamChange = (e) => {
    setSelectedTeam(e.target.value);
    fetchTeamsDashboardData(e.target.value);
  };
  useEffect(() => {
    fetchDashboardData(true);
  }, []); //eslint-disable-line
  const getAllData = (selectedProjectId) => {
    setIsRequestig(true);

    const bailerEquipments = getApi(EQUIPMENT);
    const getDashboardMapData = getApi(
      `fetch_Dashboard_Map_Detail/${selectedProjectId}`
    );
    axios
      .all([bailerEquipments, getDashboardMapData])
      .then((res) => {
        if (res[0] && res[0].data) {
          const tempdata = res[0].data.map(
            (equipments) =>
              equipments?.type?.name == "Bailer" ||
              equipments?.type?.name == "bailer"
          );
          setBailerList(tempdata);
        }
        if (res[1] && res[1].data) {
          setProjectDashboardData(res[1].data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };
  const fetchTeams = () => {
    setIsRequestig(true);

    let params = {
      sector_officer_id: selectedSectorOfficer ? selectedSectorOfficer : "",
      project_id:
        selectedProject && selectedProject.id ? selectedProject.id : "",
    };

    getApi(TEAMS, params)
      .then((res) => {
        setTeamsList(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };
  const fetchTeamsDashboardData = (selectedTeamId) => {
    setIsRequestig(true);
    let params = {
      team_id: selectedTeamId ? selectedTeamId : "",
    };

    getApi(`${FETCH_TEAM_DASHBOARD_DETAIL}/${selectedTeamId}`)
      .then((res) => {
        setTeamsDashboardData(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };
  const fetchDashboardData = (isInitialLoad) => {
    // setIsRequesting(true);
    const projects = getApi(PROJECT)
      .then(
        (res) => {
          // if (isInitialLoad) setTotalequipmentCount(res.meta.total);

          const data = res.data || [];
          // const newList = [...equipmentTypes, ...data];
          // setEquipmentTypeList(newList);
          // const tempTeamTypes = newList.map((item) =>
          //   `${item.name?.toLowerCase()}Team`.replace(/ /g, "")
          // );
          setProjectList(data);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        // setIsRequesting(false);
      });
    getApi(FETCH_DASHBOARD_DETAIL)
      .then(
        (res) => {
          // if (isInitialLoad) setTotalequipmentCount(res.meta.total);

          const data = res.data || {};
          // const newList = [...equipmentTypes, ...data];
          // setEquipmentTypeList(newList);
          // const tempTeamTypes = newList.map((item) =>
          //   `${item.name?.toLowerCase()}Team`.replace(/ /g, "")
          // );
          setDashboardData(data);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        // setIsRequesting(false);
      });
  };
  return (
    <>
      <div elevation={3}>
        <Loader isLoading={isRequesting} />
        <GridContainer
          className={`${classes.dashboardContainer} dashboard-container`}
        >
          <GridItem xs={6} sm={6} md={3} lg={4}>
            <Paper elevation={3} className="typography-paper">
              <Typography variant="h5" className="typography">
                Projects completed:{" "}
                <small>{`${dashboardData?.totalProjectsActive || "0"}`}</small>
              </Typography>
            </Paper>
          </GridItem>

          <GridItem xs={6} sm={6} md={3} lg={4}>
            <Paper elevation={3} className="typography-paper">
              <Typography variant="h5" className="typography">
                Acres covered:{" "}
                <small>
                  {" "}
                  {dashboardData?.totalAreaCovered
                    ? `${dashboardData?.totalAreaCovered.toFixed(2)}`
                    : "--"}
                </small>
              </Typography>
            </Paper>
          </GridItem>

          <GridItem xs={6} sm={6} md={3} lg={4}>
            <Paper elevation={3} className="typography-paper">
              <Typography variant="h5" className="typography">
                Bails created:{" "}
                <small>{`${dashboardData?.totalBailsCollected || "--"}`}</small>
              </Typography>
            </Paper>
          </GridItem>
        </GridContainer>

        <Divider className="divider" />

        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={8}
            lg={8}
            className="project-title-container"
          >
            <Typography variant="h4" className="project-name">
              {selectedProject?.name || "--"} Project
            </Typography>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} lg={4}>
            <FormControl fullWidth className="team-selection">
              <InputLabel id="demo-simple-select-label">
                Select Project
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedProject?.id || ""}
                label="Select "
                onChange={handleProjectChange}
              >
                {projectList && projectList.length ? (
                  projectList.map((project, idx) => (
                    <MenuItem key={idx} value={project.id}>
                      {project.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>No Option</MenuItem>
                )}
                {/* <MenuItem value={10}>Team 1</MenuItem>
                <MenuItem value={20}>Team 2</MenuItem>
                <MenuItem value={30}>Team 3</MenuItem> */}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={8} lg={8}>
            <Map
              driverMap={projectDashboardData?.driversMapDetail || []}
              dadhboardMapCoordinates={dadhboardMapCoordinates || []}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4} lg={4}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <Paper className="typography-paper">
                  <Typography variant="h5" className="typography">
                    Total Area Covered: {/* projectDashboardData */}
                    <small>
                      {" "}
                      {projectDashboardData?.totalAreaCovered
                        ? `${projectDashboardData?.totalAreaCovered}`
                        : 0}
                    </small>
                  </Typography>
                </Paper>
              </GridItem>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginTop: "20px" }}
              >
                <Paper className="typography-paper">
                  <Typography variant="h5" className="typography">
                    No. of Jobs Completed: {/* projectDashboardData */}
                    <small>
                      {" "}
                      {projectDashboardData?.totalCompletedJobCount
                        ? `${dashboardData?.totalCompletedJobCount}`
                        : "0"}
                    </small>
                  </Typography>
                </Paper>
              </GridItem>
              <GridItem
                xs={6}
                sm={6}
                md={12}
                lg={12}
                style={{ marginTop: "20px" }}
              >
                <Paper elevation={3} className="typography-paper">
                  <Typography variant="h5" className="typography">
                    No. of bails Created:{" "}
                    <small>{`${bailerList.length || "--"}`}</small>
                  </Typography>
                </Paper>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>

        {/* <GridContainer
          style={{
            // marginTop: "10px !important",
            display: "flex",
            justifyContent: "spaceBetween",
          }}
        > */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <GridItem xs={12} sm={12} md={7} lg={7}>
            <Typography variant="h5" className="bottom-title">
              Jobs Overview
            </Typography>
            <Box className="left">
              <List component="nav" aria-label="main mailbox folders">
                <Box className="flex">
                  <ListItemText primary="No. of active Jobs:" />
                  <Typography variant="body1" className="bottom-data">
                    {projectDashboardData?.totalJobCount || "0"}
                  </Typography>
                </Box>
                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Jobs Completed:" />
                  <Typography variant="body1" className="bottom-data">
                    {projectDashboardData?.totalCompletedJobCount || "0"}
                  </Typography>
                </Box>
                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Jobs Pending:" />
                  <Typography variant="body1" className="bottom-data">
                    {projectDashboardData?.totalPendingJobCount || "0"}
                  </Typography>
                </Box>
                <Divider />
              </List>
            </Box>
          </GridItem>
          <Divider orientation="vertical" flexItem />
          <GridItem xs={12} sm={12} md={7} lg={7} className="bottom-right">
            <Typography variant="h5" className="bottom-title">
              Drivers Overview
            </Typography>
            <Box className="left">
              <List component="nav" aria-label="main mailbox folders">
                <Box className="flex">
                  <ListItemText primary="No. active Drivers:" />
                  <Typography variant="body1" className="bottom-data">
                    {projectDashboardData?.totalActiveDrivers || "0"}
                  </Typography>
                </Box>
                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Drivers on break:" />
                  <Typography variant="body1" className="bottom-data">
                    {projectDashboardData?.totalActiveBreakDrivers || "0"}
                  </Typography>
                </Box>

                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Vehical/Equipment breakdown:" />
                  <Typography variant="body1" className="bottom-data">
                    {projectDashboardData?.totalVehicleBreakdown || "0"}
                  </Typography>
                </Box>
              </List>
            </Box>
          </GridItem>
        </div>

        {/* </GridContainer> */}
        <Divider className="divider" />
        {/* <GridContainer> */}
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={3} lg={3}>
              <FormControl fullWidth className="team-selection">
                <InputLabel id="demo-simple-select-label">
                  Select Sector Officer
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedSectorOfficer || ""}
                  label="Select Sector Officer"
                  onChange={handleSectorOfficerChange}
                >
                  {sectorOfficerList && sectorOfficerList.length ? (
                    sectorOfficerList.map((sectorOfficer, idx) => (
                      <MenuItem key={idx} value={sectorOfficer.id}>
                        {sectorOfficer?.user_details?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No Option</MenuItem>
                  )}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={3} lg={3}>
              <FormControl fullWidth className="team-selection">
                <InputLabel id="demo-simple-select-label">
                  Select Team
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedTeam || ""}
                  label="Select Team"
                  onChange={handleTeamChange}
                >
                  {teamsList && teamsList.length ? (
                    teamsList.map((team, idx) => (
                      <MenuItem key={idx} value={team.id}>
                        {team.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No Option</MenuItem>
                  )}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          <Divider />
        </GridItem>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <GridItem xs={12} sm={12} md={7} lg={7}>
            <Typography variant="h5" className="bottom-title">
              Jobs Overview
            </Typography>

            <Box className="left">
              <List component="nav" aria-label="main mailbox folders">
                <Box className="flex">
                  <ListItemText primary="No. of active Jobs:" />
                  <Typography variant="body1" className="bottom-data">
                    {teamsDashboardData?.totalJobCount || "0"}
                  </Typography>
                </Box>
                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Jobs Completed:" />
                  <Typography variant="body1" className="bottom-data">
                    {teamsDashboardData?.totalCompletedJobCount || "0"}
                  </Typography>
                </Box>
                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Jobs Pending:" />
                  <Typography variant="body1" className="bottom-data">
                    {teamsDashboardData?.totalPendingJobCount || "0"}
                  </Typography>
                </Box>
                <Divider />
              </List>
            </Box>
          </GridItem>
          <Divider orientation="vertical" flexItem />
          <GridItem xs={12} sm={12} md={7} lg={7} className="bottom-right">
            <Typography variant="h5" className="bottom-title">
              Drivers Overview
            </Typography>
            <Box className="left">
              <List component="nav" aria-label="main mailbox folders">
                <Box className="flex">
                  <ListItemText primary="No. active Drivers:" />
                  <Typography variant="body1" className="bottom-data">
                    {teamsDashboardData?.totalActiveDrivers || "0"}
                  </Typography>
                </Box>
                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Drivers on break:" />
                  <Typography variant="body1" className="bottom-data">
                    {teamsDashboardData?.totalActiveBreakDrivers || "0"}
                  </Typography>
                </Box>

                <Divider />
                <Box className="flex">
                  <ListItemText primary="No. of Vehical/Equipment breakdown:" />
                  <Typography variant="body1" className="bottom-data">
                    {teamsDashboardData?.totalVehicleBreakdown || "0"}
                  </Typography>
                </Box>
              </List>
            </Box>
          </GridItem>
        </div>
        {/* </GridContainer> */}
        <Divider className="divider" />
      </div>
    </>
  );
}
